// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2itRw","largestCol":"styles_largestCol__-YVsw","smallestCol":"styles_smallestCol__3JPQn"};